export enum PermissionType {
    //* ADMIN PERMISSION
    Read = 'Read',
    Write = 'Write',
    Export = 'Export',
    ContentCreate = 'ContentCreate',
    ContentSynchronization = 'ContentSynchronization',

    //* CONTENT PERMISSIONS
    ContentReadDraft = 'ContentReadDraft',
    ContentEditDraft = 'ContentEditDraft',
    ContentReadPublished = 'ContentReadPublished',
    ContentEditPublished = 'ContentEditPublished',
    ContentPublish = 'ContentPublish',
    ContentUnpublish = 'ContentUnpublish',

    ContentNotifications = 'ContentNotifications',

    ContentReadResults = 'ContentReadResults',

}